// Month/period dropdown for the Sources page — the shared Menu primitive, but
// driven by the same report list the dashboard's selector uses
// (useReportPeriods). Picking a month navigates to that report's Sources route,
// re-keying the data.

import React from "react";
import { ChevronDown } from "lucide-react";
import { Menu, MenuItem } from "@/components/vb";
import type { ReportPeriod } from "@/hooks/vb/useReportPeriods";

interface PeriodMenuProps {
  periods: ReportPeriod[];
  currentId: number | undefined;
  onSelect: (id: number) => void;
}

export function PeriodMenu({ periods, currentId, onSelect }: PeriodMenuProps) {
  const current = periods.find((p) => p.id === currentId);
  return (
    <Menu
      align="end"
      ariaLabel="Select report month"
      trigger={
        <button type="button" className="vb-btn vb-btn--sm src-period-btn">
          {current?.label ?? "Select month"}
          <ChevronDown size={12} aria-hidden="true" />
        </button>
      }
    >
      {periods.map((p) => (
        <MenuItem
          key={p.id}
          role="menuitemradio"
          selected={p.id === currentId}
          onSelect={() => {
            if (p.id !== currentId) onSelect(p.id);
          }}
        >
          {p.label}
        </MenuItem>
      ))}
    </Menu>
  );
}

export default PeriodMenu;
